import Vue from 'vue'
import SymbolConfig from "./symbol-config"
import externalPoster from './card/external-Poster.vue'
import selfdefineCard from './card/selfdefine-card.vue'
import externalImgText from './card/external-img-text.vue'
import shopCardPhone from './card/house-phone.vue'
import houseEnroll from './card/house-enroll.vue'
import externalQrcode from './card/external-qrcode.vue'
import vote from './card/vote/index.vue'
import ShopCardVideo from './card/external-video.vue'
import { renderRecModule } from './recommend/index.js'
import "./css/index.less";
import { getCardInfo } from '../../request/request'
export const renderArticleInsert = function() {
    try {
        let shopInfoObj= []
        init()

        function init() {
                const mpPluginList = document.querySelectorAll('#mp-editor mp-plugin')
                if(mpPluginList?.length) {
                    mpPluginList.forEach((plugin)=>{
                        const type =  plugin?.getAttribute('data-type')
                        if(type) {
                            const item = {}
                            const info = eval(plugin?.getAttribute('data-info'))
                            if (SymbolConfig.shopCard.indexOf(+type) > -1 && info && info[0]) {
                                var key = info[0].cardUuid;
                                item.id = key
                                item.type = type
                                item.$el = plugin
                                shopInfoObj.push(item)
                            } else {
                                renderRecModule(plugin)
                            }
                        }
                    })
                    renderShopCard(shopInfoObj)
                }
        }
        function renderShopCard(params) {
            if(!params.length)return
            var ids = []
            params.forEach(function(item){
                ids.push(item.id)
            })
            if (ids?.length) {
                getCardInfo({
                    ids: ids.join(","),
                    _t: new Date().getTime()
                }).then((res)=>{
                    if(res && res.code == 2000000 && res.data?.length) {
                        const dataList = res.data
                        dataList.forEach((cardItem,i)=>{
                            const pluginType = cardItem?.pluginType // 功能卡类型
                            cardItem.$el = shopInfoObj[i]?.$el
                            getCardComp(pluginType,cardItem)
                        })
                    }
                })
            }
        }
        // by cardType渲染对应功能卡
        function getCardComp(pluginType,cardInfo) {
            if(!pluginType) return
            const cardType = SymbolConfig.cardTypeMap[pluginType]
            const cardTypeFnMap = {
                shopCardEnroll: renderShopCardEnroll,
                shopCardPhone: renderShopCardPhone,
                shopCardPoster: renderShopCardPoster,
                shopCardImgText: renderShopCardImgText,
                shopCardVideo: renderShopCardVideo,
                shopCardQrcode: renderShopCardQrcode,
                shopCardVote: renderShopCardVote,
                selfdefineCard: renderSelfdefineCard,
            }
            return cardTypeFnMap[cardType](cardInfo)
        }
        // type 30, 32
        function renderShopCardEnroll(cardInfo){
            const params = {
				el: document.createElement('div'),
				propsData:{
					cardInfo: cardInfo
				},
			}
            const vueConstructor = Vue.extend(houseEnroll)
            const html = new vueConstructor(params)?.$el
            cardInfo?.$el?.appendChild(html)
        }
        // type 31, 33
        function renderShopCardPhone(cardInfo){
            const params = {
				el: document.createElement('div'),
				propsData:{
					cardInfo: cardInfo
				},
			}
            const vueConstructor = Vue.extend(shopCardPhone)
            const html = new vueConstructor(params)?.$el
            cardInfo?.$el?.appendChild(html)
        }
        // type 35, 36,64,65
        function renderShopCardPoster(cardInfo){
            const params = {
				el: document.createElement('div'),
				propsData:{
					cardInfo: cardInfo
				},
			}
            const vueConstructor = Vue.extend(externalPoster)
            const html = new vueConstructor(params)?.$el
            cardInfo?.$el?.appendChild(html)
        }
        // type 34, 51,63
        function renderShopCardImgText(cardInfo){
            const params = {
				el: document.createElement('div'),
				propsData:{
					cardInfo: cardInfo
				},
			}
            const vueConstructor = Vue.extend(externalImgText)
            const html = new vueConstructor(params)?.$el
            cardInfo?.$el?.appendChild(html)
        }
        // type 37, 38, 39
        function renderShopCardVideo(cardInfo){
            const params = {
                el: document.createElement('div'),
                propsData:{
                    cardInfo: cardInfo
                },
            }
            const vueConstructor = Vue.extend(ShopCardVideo)
            const html = new vueConstructor(params)?.$el
            cardInfo?.$el?.appendChild(html)
        }
        // type 47
        function renderShopCardQrcode(cardInfo){
            const status = cardInfo?.status
            if(status == 1 || status == 5) {
                const params = {
                    el: document.createElement('div'),
                    propsData:{
                        cardInfo: cardInfo
                    },
                }
                const vueConstructor = Vue.extend(externalQrcode)
                const html = new vueConstructor(params)?.$el
                cardInfo?.$el?.appendChild(html)
            }
        }
        // type 66
        function renderShopCardVote(cardInfo){
            const params = {
                el: document.createElement('div'),
                propsData:{
                    articleData: cardInfo
                },
            }
            const vueConstructor = Vue.extend(vote)
            const html = new vueConstructor(params)?.$el
            cardInfo?.$el?.appendChild(html)
        }
        function renderSelfdefineCard(cardInfo) {
            const params = {
                el: document.createElement('div'),
                propsData:{
                    cardInfo: cardInfo
                },
            }
            const vueConstructor = Vue.extend(selfdefineCard)
            const html = new vueConstructor(params)?.$el
            cardInfo?.$el?.appendChild(html)
        }


    } catch (error) {
        console.log('功能卡',error)
    }
}



